import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import './redesign.css';
import './balanced-grids.css';
import './site-polish.css';

const navLinks = [
  { href: '/', label: 'главная' },
  { href: '/services/vseuslugi/', label: 'услуги', hasDropdown: true },
  { href: '/calculator/', label: 'калькулятор' },
  { href: '/portfolio/', label: 'портфолио' },
  { href: '/blog/', label: 'блог' },
  { href: '/about/', label: 'о компании' },
  { href: '/contacts/', label: 'контакты' },
];

export const socialLinks = {
  telegram: {
    label: 'Telegram',
    href: 'https://t.me/giz_official',
  },
  max: {
    label: 'Max',
    href: 'https://max.ru/u/f9LHodD0cOJp3020eUc1s0iy3LpfytHJmpLxIXdYBQ_obhBGipvCtfqI0Y4',
  },
  vk: {
    label: 'VK',
    href: 'https://vk.com/giz_official',
  },
  whatsapp: {
    label: 'WhatsApp',
    href: 'https://wa.me/79256530454',
  },
  telegramChannel: {
    label: 'Telegram',
    href: 'https://t.me/fatality_dp',
  },
  vkChannel: {
    label: 'VK',
    href: 'https://vk.com/da_fatality',
  },
};

const SocialIcon = ({ type }) => {
  if (type === 'telegram') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 4 3.8 10.6c-1.1.4-1.1 1.1-.2 1.4l4.4 1.4 1.7 5.2c.2.7.6.8 1.1.3l2.5-2.4 4.8 3.5c.9.5 1.5.3 1.7-.8L23 5.6c.3-1.1-.4-1.6-2-1.1Zm-11.8 9 9.9-6.2c.5-.3.9-.1.5.2l-8 7.2-.3 3-1.4-4.2Z" />
      </svg>
    );
  }

  if (type === 'vk') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3.4 7.1c.1 5.6 2.9 9 7.8 9.4h.3v-3.2c2.1.2 3.7 1.8 4.4 3.2h3.2c-.9-2-2.4-3.5-4.3-4.1 1.9-.9 3.2-2.7 3.9-5.3h-2.9c-.6 1.9-2.2 3.7-4.3 3.9V7.1H8.6v6.8c-2.1-.5-3.5-2.6-3.6-6.8H3.4Z" />
      </svg>
    );
  }

  if (type === 'whatsapp') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3.2a8.6 8.6 0 0 0-7.4 13l-1 4.1 4.2-1a8.6 8.6 0 1 0 4.2-16.1Zm0 1.8a6.8 6.8 0 0 1 5.8 10.4 6.8 6.8 0 0 1-8.2 2.4l-.4-.2-2.5.6.6-2.4-.2-.4A6.8 6.8 0 0 1 12 5Zm-2.2 3.6c-.2 0-.5.1-.7.4-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.8 2.9 4.5 3.9 2.2.9 2.7.5 3.2.4.5-.1 1.5-.7 1.7-1.3.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.6-.4l-1.8-.9c-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-1.6-.8-2.6-1.5-3.5-3.2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.8-1.9c-.2-.4-.4-.4-.7-.4h-.2Z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 5h16v14H4V5Zm3 10h2.1V9.8l2.1 5.2h1.6l2.1-5.2V15H17V8h-3.2L12 12.5 10.2 8H7v7Z" />
    </svg>
  );
};

export function SocialIconLink({ type, className = '', label, href }) {
  const item = socialLinks[type] || { label, href };

  return (
    <a
      className={`social-icon-link ${className}`.trim()}
      href={href || item.href}
      aria-label={label || item.label}
      title={label || item.label}
      target="_blank"
      rel="noreferrer"
    >
      <SocialIcon type={type} />
      <span>{label || item.label}</span>
    </a>
  );
}

export const serviceMenuGroups = [
  {
    title: 'Разработка сайтов',
    href: '/services/websites/',
    links: [
      { href: '/services/websites/corporate/', label: 'Корпоративные сайты' },
      { href: '/services/websites/landing/', label: 'Лендинги' },
      { href: '/services/websites/ecommerce/', label: 'Интернет-магазины' },
      { href: '/services/websites/seo/', label: 'Разработка под SEO' },
      { href: '/services/websites/full-cycle/', label: 'Разработка сайта под ключ' },
      { href: '/services/websites/redesign-support/', label: 'Редизайн и поддержка' },
    ],
  },
  {
    title: 'Разработка приложений',
    href: '/services/mobile/',
    links: [
      { href: '/services/mobile/mvp/', label: 'MVP' },
      { href: '/services/mobile/ios/', label: 'iOS' },
      { href: '/services/mobile/android/', label: 'Android' },
      { href: '/services/mobile/integrations/', label: 'Интеграции' },
      { href: '/services/mobile/publishing/', label: 'Публикация', children: [
        { href: '/services/mobile/publishing/app-store/', label: 'App Store' },
        { href: '/services/mobile/publishing/google-play/', label: 'Google Play' },
        { href: '/services/mobile/publishing/rustore/', label: 'RuStore' },
      ] },
      { href: '/services/mobile/aso/', label: 'ASO-продвижение' },
    ],
  },
  {
    title: 'Разработка Mini Apps и ботов',
    href: '/services/mini-apps/',
    links: [
      { href: '/services/mini-apps/telegram/', label: 'Telegram Mini App' },
      { href: '/services/mini-apps/vk/', label: 'VK Mini App' },
      { href: '/services/mini-apps/max/', label: 'Max Mini App' },
      { href: '/services/mini-apps/bots/', label: 'Боты и чат-боты' },
      { href: '/services/mini-apps/support/', label: 'Поддержка' },
    ],
  },
  {
    title: 'SEO-услуги и продвижение',
    href: '/services/seo/',
    links: [
      { href: '/services/seo/full-cycle/', label: 'SEO под ключ' },
      { href: '/services/seo/audit/', label: 'Аудит' },
      { href: '/services/seo/technical/', label: 'Техническое SEO' },
      { href: '/services/seo/internal/', label: 'Внутренняя оптимизация' },
      { href: '/services/seo/external/', label: 'Внешнее продвижение' },
    ],
  },
  {
    title: 'Продвижение в Яндекс.Картах',
    href: '/services/yandex-maps/',
    links: [],
  },
];

const footerColumns = [
  {
    title: 'услуги',
    links: [
      { href: '/services/websites/', label: 'Разработка сайтов' },
      { href: '/services/websites/redesign-support/', label: 'Редизайн и поддержка сайтов' },
      { href: '/services/mobile/mvp/', label: 'Разработка MVP' },
      { href: '/services/mobile/', label: 'Разработка мобильных приложений' },
      { href: '/services/mobile/support/', label: 'Поддержка мобильных приложений' },
      { href: '/services/mini-apps/', label: 'Разработка Mini Apps' },
      { href: '/services/seo/', label: 'Seo-оптимизация' },
      { href: '/services/yandex-maps/', label: 'Продвижение в Яндекс.Картах' },
    ],
  },
  {
    title: 'навигация',
    links: [
      { href: '/calculator/', label: 'калькулятор разработки' },
      { href: '/portfolio/', label: 'портфолио' },
      { href: '/blog/', label: 'блог' },
      { href: '/about/', label: 'о компании' },
      { href: '/contacts/', label: 'контакты' },
    ],
  },
  {
    title: 'компания',
    links: [
      { href: '/vacancies/', label: 'Вакансии' },
      { href: '/requisites/', label: 'Реквизиты' },
    ],
  },
  {
    title: 'документы',
    links: [
      { href: '/privacy/', label: 'политика конфиденциальности' },
      { href: '/offer/', label: 'оферта' },
      { href: '/cookies/', label: 'cookies' },
    ],
  },
];

const normalizePath = (path) => {
  if (!path) return '/';
  const cleanPath = path.split('#')[0].split('?')[0];
  if (cleanPath === '/') return '/';
  return cleanPath.replace(/\/$/, '');
};

export function SiteLink({ href, children, className, title, onClick, ...rest }) {
  const handleHashClick = (event) => {
    if (onClick) onClick(event);
    if (event.defaultPrevented) return;

    if (href?.startsWith('/#') && window.location.pathname === '/') {
      const target = document.querySelector(href.slice(1));
      if (target) {
        event.preventDefault();
        window.history.pushState(null, '', href);
        window.scrollTo({ top: target.offsetTop - 72, behavior: 'smooth' });
      }
    }
  };

  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
    return (
      <a href={href} className={className} title={title} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }

  if (/^https?:\/\//.test(href)) {
    return (
      <a href={href} className={className} title={title} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className} title={title} onClick={handleHashClick} {...rest}>
      {children}
    </Link>
  );
}

function ServiceMenuBranch({ link, mobile = false, onNavigate }) {
  const [open, setOpen] = useState(false);
  const toggleRef = useRef(null);
  const location = useLocation();
  const id = `${mobile ? 'mobile' : 'desktop'}-submenu-${link.href.replace(/[^a-z0-9]+/gi, '-')}`;
  useEffect(() => setOpen(false), [location.pathname, location.hash]);

  return (
    <div className="service-menu-branch"
      onMouseEnter={() => { if (!mobile) setOpen(true); }}
      onMouseLeave={(event) => {
        if (!mobile && !event.currentTarget.contains(document.activeElement)) setOpen(false);
      }}
      onBlur={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          setOpen(false);
          toggleRef.current?.focus();
        }
      }}
    >
      <div className="service-menu-branch-row">
        <SiteLink href={link.href} onClick={onNavigate} onFocus={() => { if (!mobile) setOpen(true); }}>
          {link.label}
        </SiteLink>
        <button ref={toggleRef} type="button" className="service-submenu-toggle"
          aria-label={`${open ? 'Свернуть' : 'Раскрыть'} подразделы: ${link.label}`}
          aria-expanded={open} aria-controls={id} onClick={() => setOpen(value => !value)}>
          <span aria-hidden="true">⌄</span>
        </button>
      </div>
      <ul className="service-submenu" id={id} hidden={!open} aria-label={`${link.label} — подразделы`}>
        {link.children.map(child => <li key={child.href}><SiteLink href={child.href} onClick={onNavigate}>{child.label}</SiteLink></li>)}
      </ul>
    </div>
  );
}

export function RedesignHeader() {
  const location = useLocation();
  const currentPath = normalizePath(location.pathname);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isMobileServicesOpen, setMobileServicesOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
    setMobileServicesOpen(false);
  }, [location.pathname, location.hash]);

  const closeMenu = () => {
    setMenuOpen(false);
    setMobileServicesOpen(false);
  };
  const toggleMenu = () => setMenuOpen((open) => !open);
  const toggleMobileServices = () => setMobileServicesOpen((open) => !open);

  return (
    <header className="nav">
      <div className="container nav-inner">
        <SiteLink href="/" className="wordmark-logo" aria-label="Fatality — на главную">
          <span className="wordmark-mark" aria-hidden="true">
            F/
          </span>
          <span className="wordmark-text">
            fatal<span className="wordmark-it">it</span>y
          </span>
        </SiteLink>
        <nav className="nav-links" aria-label="Основная навигация">
          {navLinks.map((item) => (
            <div className={`nav-item${item.hasDropdown ? ' has-dropdown' : ''}`} key={item.href}>
              <SiteLink
                href={item.href}
                className={
                  normalizePath(item.href) === currentPath ||
                  (item.hasDropdown && currentPath.startsWith('/services'))
                    ? 'current'
                    : undefined
                }
              >
                {item.label}
              </SiteLink>
              {item.hasDropdown && (
                <div className="services-menu" role="menu">
                  <div className="services-menu-inner">
                    {serviceMenuGroups.map((group) => (
                      <div className="services-menu-group" key={group.title}>
                        <SiteLink href={group.href} className="services-menu-title">
                          {group.title}
                        </SiteLink>
                        {group.links.length > 0 && (
                          <ul>
                            {group.links.map((link) => (
                              <li key={link.href}>
                                {link.children?.length ? <ServiceMenuBranch link={link} /> : <SiteLink href={link.href}>{link.label}</SiteLink>}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>
        <div className="nav-cta">
          <SocialIconLink type="telegram" className="nav-social-link" label="Telegram @giz_official" />
          <a className="nav-phone" href="tel:+79256530454">
            +7 (925) 653-04-54
          </a>
          <SiteLink href="/#lead" className="btn btn-primary btn-sm">
            обсудить →
          </SiteLink>
          <button
            className={`mobile-menu-toggle${isMenuOpen ? ' is-open' : ''}`}
            type="button"
            aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-navigation"
            onClick={toggleMenu}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      {isMenuOpen && (
        <div className="mobile-menu-panel" id="mobile-navigation">
          <div className="container mobile-menu-inner">
            <nav className="mobile-menu-main" aria-label="Мобильная навигация">
              {navLinks.map((item) => {
                const isCurrent =
                  normalizePath(item.href) === currentPath ||
                  (item.hasDropdown && currentPath.startsWith('/services'));

                if (item.hasDropdown) {
                  return (
                    <button
                      className={`mobile-menu-trigger${isCurrent ? ' current' : ''}${isMobileServicesOpen ? ' is-open' : ''}`}
                      type="button"
                      aria-expanded={isMobileServicesOpen}
                      aria-controls="mobile-services-dropdown"
                      onClick={toggleMobileServices}
                      key={item.href}
                    >
                      <span>{item.label}</span>
                      <span className="mobile-menu-caret" aria-hidden="true" />
                    </button>
                  );
                }

                return (
                  <SiteLink
                    href={item.href}
                    className={isCurrent ? 'current' : undefined}
                    onClick={closeMenu}
                    key={item.href}
                  >
                    {item.label}
                  </SiteLink>
                );
              })}
            </nav>
            {isMobileServicesOpen && (
              <div className="mobile-menu-services" id="mobile-services-dropdown">
                <div className="mobile-menu-label">услуги</div>
                <SiteLink href="/services/vseuslugi/" className="mobile-services-index" onClick={closeMenu}>
                  все услуги
                </SiteLink>
                {serviceMenuGroups.map((group) => (
                  <div className="mobile-service-group" key={group.title}>
                    <SiteLink href={group.href} className="mobile-service-title" onClick={closeMenu}>
                      {group.title}
                    </SiteLink>
                    {group.links.length > 0 && (
                      <div className="mobile-service-links">
                        {group.links.map((link) => (
                          link.children?.length ? <ServiceMenuBranch key={link.href} link={link} mobile onNavigate={closeMenu} /> : (
                            <SiteLink href={link.href} onClick={closeMenu} key={link.href}>{link.label}</SiteLink>
                          )
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
            <div className="mobile-menu-contact">
              <a href="tel:+79256530454" onClick={closeMenu}>
                +7 (925) 653-04-54
              </a>
              <SocialIconLink type="telegram" className="mobile-contact-social" label="Telegram" />
              <SiteLink href="/#lead" className="btn btn-primary" onClick={closeMenu}>
                обсудить проект →
              </SiteLink>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export function RedesignFooter() {
  return (
    <footer data-screen-label="10 footer">
      <div
        className="glow"
        style={{ right: '-300px', bottom: '-300px', width: '700px', height: '700px', opacity: 0.08 }}
      />
      <div className="container" style={{ position: 'relative' }}>
        <div className="foot-top">
          <div className="foot-brand">
            <div className="logo">
              F<span>/</span>
            </div>
            <div className="foot-tagline">
              Digital-агентство полного цикла. <span className="accent">с 2019 года</span> в Москве.
            </div>
            <div className="foot-contacts">
              <div className="lbl">контакты</div>
              <div>
                <a href="mailto:fatality.develop@gmail.com">fatality.develop@gmail.com</a>
              </div>
              <div>
                <a href="tel:+79256530454">+7 (925) 653-04-54</a>
              </div>
              <div className="lbl">офис</div>
              <div>Москва</div>
              <div className="lbl">соцсети</div>
              <div className="foot-socials">
                <SocialIconLink type="telegram" label="Telegram" />
                <SocialIconLink type="max" label="Max" />
                <SocialIconLink type="whatsapp" label="WhatsApp" />
                <SocialIconLink type="vk" label="VK" />
              </div>
            </div>
          </div>

          <div className="foot-cols">
            {footerColumns.map((column) => (
              <div className="foot-col" key={column.title}>
                <div className="foot-col-title">{column.title}</div>
                <ul>
                  {column.links.map((link) => (
                    <li key={link.href}>
                      <SiteLink href={link.href}>{link.label}</SiteLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="foot-bot">
          <span>© 2019–2026 fatality · ИП Фаталиев Гияс Хазар оглы · ИНН 771819238234</span>
        </div>
      </div>
    </footer>
  );
}

export function RedesignPage({ children }) {
  return <div className="fatality-redesign">{children}</div>;
}
